import { Form, Input } from 'antd';
import { useIntl } from 'react-intl';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as LocationIcon } from 'assets/bosta-icons/Location.svg';

import './LatLngForm.less';

const LatLngForm = ({ handlePlotGeolocation }) => {
  const intl = useIntl();

  const onFinish = (values) => {
    if (values.lat && values.lng) {
      handlePlotGeolocation(values);
    }
  };
  return (
    <Form className="br-lat-lng__form" onFinish={onFinish}>
      <div className="br-lat-lng-form__row">
        <Form.Item
          name="lat"
          label={intl.formatMessage({
            id: 'hubs_geofencing.control_panel.latitude'
          })}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="lng"
          label={intl.formatMessage({
            id: 'hubs_geofencing.control_panel.longitude'
          })}
        >
          <Input />
        </Form.Item>
      </div>
      <BRButton
        htmlType="submit"
        label={intl.formatMessage({
          id: 'hubs_geofencing.control_panel.take_me_there'
        })}
        prefixIcon={<LocationIcon />}
        block
      />
    </Form>
  );
};

export default LatLngForm;
